import { rootApi } from '@store/root-api';
import api from 'services/api';
import {
  AskApi,
  AskConversationRequestDto,
  AskConversationResponseDto,
  AskRequestDto,
  AskResponseDto,
  TradeIntentRequestDto,
  TradeIntentResultDto,
} from 'services/generated';
import { handleErrors } from 'services/helpers';

const askClient = new AskApi(undefined, undefined, api);
export const aiInsightsApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    askConversationQuestion: builder.mutation<
      AskConversationResponseDto,
      AskConversationRequestDto
    >({
      queryFn: request =>
        handleErrors(() => askClient.askConversation(request)),
    }),
    askIntent: builder.mutation<TradeIntentResultDto, TradeIntentRequestDto>({
      queryFn: request => handleErrors(() => askClient.askTradeIntent(request)),
    }),
    askQuestion: builder.query<AskResponseDto, AskRequestDto>({
      queryFn: request => {
        const apiCall = () => {
          switch (request.pageName.toLowerCase()) {
            case 'portfolio':
              return askClient.askPortfolio(request);
            case 'assets':
              return askClient.askProduct(request);
            case 'explore':
            default:
              return askClient.askExplore(request);
          }
        };
        return handleErrors(apiCall);
      },
      keepUnusedDataFor: 300, // Cache for 5 minutes (300 seconds)
      providesTags: (_result, _error, request) => [
        { type: 'AiInsights', id: request.question },
        'AiInsights',
      ],
    }),
  }),
});

export const {
  useAskQuestionQuery,
  useAskConversationQuestionMutation,
  useAskIntentMutation,
} = aiInsightsApi;
